import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import LandingHeader from "../components/LandingHeader";
import LandingFooter from "../components/LandingFooter";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>The 10 Secrets Successful Agents Use To Adapt To Shifting Markets Guide - courtesy of Elm Street</title>
        <meta
          name="description"
          content="Those who do not adapt, churn out, and the number of agents who failed in their first few years is already high - almost 90%. That's why at Elm Street we empower agents on strategies like the ones we have listed below, and we hope that this guide will spark some inspiration for your real estate business."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/10secrets" />
        <meta property="og:title" content="10 Secrets Guide - courtesy of Elm Street" />
        <meta
          property="og:description"
          content="Those who do not adapt, churn out, and the number of agents who failed in their first few years is already high - almost 90%. That's why at Elm Street we empower agents on strategies like the ones we have listed below, and we hope that this guide will spark some inspiration for your real estate business."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />

      <LandingHeader />

      <div
        style={{
          backgroundImage: "url('esbg3.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h2" component="h1" style={{ color: "#ffffff" }}>
                  <span style={{ color: "#f69c26" }}>
                  The 10 Secrets Successful Agents Use <span style={{ color: "#ffffff" }}>To Adapt To Shifting Markets Guide</span>
                  </span>
                  
                </Typography>
                <br />
                <span style={{ color: "#ffffff" }}>
                  
                The market will always shift, and successful agents are the ones who can adapt and overcome the obstacles that take down agents who aren't as equipped to shift with the market. We want to help equip you!
Download our complimentary, in-depth guide into the secrets and strategies that top-performing agents are using to succeed in the shifting market.
                </span>
              </Grid>
              <Grid item md={6} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image src="/successful_cover.jpg" width="700px" height="892px" alt="10 Secrets cover"/>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ textAlign: "left" }}>
        <div style={{ marginTop: "68px", marginBottom: "68px" }}>
          <Grid container spacing={8} justifyContent="center">
            <Grid item md={8}>
            <DemoForm
              buttonText="Download Now"
              successMsg={<div style={{textAlign:"center"}}><strong>Thank you for your interest!</strong><br/><br/><Button variant="contained" color="secondary" href="/assets/es-successful.pdf">Download the PDF</Button></div>}
              formName="es2_10secrets" listId="148012"
              fieldList={["first_name", "last_name", "email", "phone", "roll"]}
            />
            </Grid>
          </Grid>
        </div>
      </Container>

      <LandingFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
